
import React, {useContext} from 'react';
import AppConstants from 'AppConstants';
import OrderFormLoader from 'views/order/OrderFormLoader';

import OrderAPI from 'service/api/OrderAPI';

import ProductSocialShare from 'views/product/ProductSocialShare';
import PhotoFrameSizeInput from 'views/order/input/PhotoFrameSizeInput';

import LocationTypeInput, {AddressInput} from 'views/order/input/LocationTypeInput';
import CouponCodeInput from 'views/order/input/CouponCodeInput';
import PaymentPreferenceInput from 'views/order/input/PaymentPreferenceInput';
import {TotalCost, ErrorMessages, SubmitBtn, OrderInfo} from 'views/order/OrderForm';
import { Formik } from 'formik';
import OrderConfirmation from 'views/order/OrderConfirmation';
import Yup from 'yup';
import ProductOrderForm from 'views/order/ProductOrderForm';

import FrameImageUploader from 'views/order/input/FrameImageUploader';
import {OrderContext} from 'views/order/OrderForm';
import {RGForm, Input, RadioButton} from 'views/FormElements';
import AppUtil from 'AppUtil';


const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;


const QuantityInput = () => {

    return <div id="frameQuantityOption">
            <h3>Quantity</h3>
            <Input name="quantity" type="number" />
        </div>
}

const MattingInput = () => {
    const {values} = useContext(OrderContext);
    return <React.Fragment>
            <h3>Matting <span style={{fontSize: '70%'}}>(1" in width)</span></h3>
            <div className="flexRow">
                <RadioButton name="matting" value={"White"} label={<span style={{color: '#596161', marginRight: '15px'}}>White Matting</span>} checked={values.matting === "White"} />
                {/* <RadioButton name="matting" value={"Black"} label={<span style={{color: '#596161', marginRight: '15px'}}>Black Matting</span>} checked={values.matting === "Black"} /> */}
                <RadioButton name="matting" value={""} label={<span style={{color: '#596161'}}>No Matting</span>} checked={values.matting === ""} />
            </div> 
    </React.Fragment>
};

const BorderColorInput = () => {
    const {values} = useContext(OrderContext);
    return <React.Fragment>
            <h3>Border <span style={{fontSize: '70%'}}>(1" in width)</span></h3>
            <div className="flexRow">
                <RadioButton name="borderColor" value={"blackBorder"} label={<span style={{color: '#596161', marginRight: '15px'}}>Black Border</span>} checked={values.borderColor === "blackBorder"} />
                <RadioButton name="borderColor" value={"whiteBorder"} label={<span style={{color: '#596161'}}>White Border</span>} checked={values.borderColor === "whiteBorder"} />
            </div> 
    </React.Fragment>
};



class PhotoFrameForm extends ProductOrderForm {
    static contextType = OrderContext;

    constructor(props) {
        super(props);
        this.handleFormSubmission = this.handleFormSubmission.bind(this);
        this.setSubmittedOrder = this.setSubmittedOrder.bind(this);
        this.createOrderRequest = this.createOrderRequest.bind(this);
        this.displayDeliveryInputs = this.displayDeliveryInputs.bind(this);
    }

    initialValues() {
        let formValues = super.initialValues();
        formValues.productPrice = PRODUCT_TYPES['PHOTO_FRAME'].basePrice;
        formValues.paymentPreference = '';
        formValues.customerUploadedImage = null;
        formValues.matting = '';
        formValues.borderColor = 'blackBorder';
        formValues.productSizeMetaData = '';
        formValues.productSize = '';
        formValues.isCustomSize = '';
        formValues.customWidth = '';
        formValues.customHeight = '';

        formValues.imgWidth = (this.props.product && this.props.product.imgWidthPx)? this.props.product.imgWidthPx: '';
        formValues.imgHeight = (this.props.product && this.props.product.imgHeightPx)? this.props.product.imgHeightPx: '';
        
		return formValues;
	}

    validationScheme(isCustomProduct) {
		const validation = super.validationScheme();
        delete validation['productImage'];

        validation.customerUploadedImage = isCustomProduct? Yup.mixed().required("Please Upload an image"): Yup.mixed();

        return Yup.object().shape(validation);
    }

    createOrderRequest(formValue) {
        let order = super.createOrderRequest(formValue);

        const selectedSize = formValue.productSize;
        order.sizeMetaData = {};
        order.sizeMetaData[selectedSize] = formValue.productSizeMetaData[selectedSize];

        order.orderMetaData = order.orderMetaData || {};
        order.orderMetaData['DPI'] = formValue.productSizeMetaData[selectedSize].dpi;
        if(formValue.matting !== '') {
            order.orderMetaData['matting'] = formValue.matting;
        }

        if(formValue.borderColor !== '') {
            order.orderMetaData['borderColor'] = formValue.borderColor;
        }

		return order;
    }
    
    setSubmittedOrder(setStatus, formValues, discountCoupon) {
		const orderReq = this.createOrderRequest(formValues);
        //Note: This overrides other status if any
        setStatus({submittedOrder: orderReq, discountCoupon: discountCoupon});
	}

    isPrePaymentRequired(isCustomProduct) {
		return isCustomProduct? true: false;
	}

    handleFormSubmission(value, {setSubmitting, setStatus}) {
        const couponCode = value.hasCouponCode? value.couponCode: null;

		if(couponCode) {
			OrderAPI.validateDiscountCoupon(couponCode, this.props.product.id, function(success, discountCoupon) {
				if(success) {
					this.setSubmittedOrder(setStatus, value, discountCoupon);
				} else {
					setSubmitting(false);
				}
			}.bind(this));
		} else {
			this.setSubmittedOrder(setStatus, value);
		}
    }

    displayDeliveryInputs(values, isCustomProduct) {
        const quantity = values.quantity;
        const customerImg = values.customerUploadedImage;
        const isSizeProvided = values.productSize !== '';
        
        if(!isCustomProduct)
            return !isNaN(quantity) && isSizeProvided;
        else
            return !isNaN(quantity) && isSizeProvided && customerImg !== null;
    }

    render() {
        const product = this.props.product;

        if(product === null)
            return <OrderFormLoader />;

        const isCustomProduct = AppUtil.isCustomProduct(product);
        const initialValues = this.initialValues();
        const validationScheme = this.validationScheme(isCustomProduct);
        const isPrePaymentRequired = this.isPrePaymentRequired(isCustomProduct);

        return <Formik enableReinitialize initialValues={initialValues} onSubmit={this.handleFormSubmission}
                    validationSchema={validationScheme}
                    render={(formikProps) => {
                        const values = formikProps.values;
                        const status = formikProps.status;
                        const submittedOrder = status && status.submittedOrder? status.submittedOrder: null;

                        if(submittedOrder) {
                            return <OrderConfirmation order={submittedOrder} 
                                    product={product}
                                    discountCoupon={status.discountCoupon} 
                                    customerImage={values.customerUploadedImage}
                                    onClose={(reset) => {
                                        formikProps.setStatus({});//remove subittedOrder from status
                                        formikProps.setSubmitting(false);

                                        if(reset === true)
                                            formikProps.resetForm();
                                    }}/>
                        }

                        const displayDeliveryInputs = this.displayDeliveryInputs(values, isCustomProduct);

                        return <OrderContext.Provider value={{product: product, 
                                    ...formikProps}}>
                                <div id="customFrameFormContainer">
                                    <RGForm>
                                        <div style={{margin: '20px 0'}} className="flexRow">
                                            <FrameImageUploader isCustomProduct={isCustomProduct} 
                                                        imgSrc={isCustomProduct? null: product.previewImage} />

                                            <div className="flexColumn" id="customFrameInputSection">
                                                {
                                                    values.productSize &&
                                                    <div id="totalCostAtTop">
                                                        <TotalCost key="totalCostAtTop" showPriceOnly={true} />
                                                    </div>
                                                }
                                                
                                                <input type="hidden" name="productSizeMetaData" value={values.productSizeMetaData.toString()} />
                                                
                                                <PhotoFrameSizeInput imgWidth={values.imgWidth} imgHeight={values.imgHeight} />  
                                                <Input type="hidden" mui='off' name="productSize" value={values.productSize} />

                                                {/* <BorderColorInput /> */}
                                                <MattingInput /> 
                                                
                                                <QuantityInput />
                                                {
                                                    displayDeliveryInputs && 
                                                    <React.Fragment>
                                                        <h2>Delivery Detail</h2>
                                                        <LocationTypeInput />
                                                        <AddressInput />

                                                        <CouponCodeInput />

                                                        <h2>Payment Preference</h2>
                                                        <PaymentPreferenceInput prepaymentRequired={isPrePaymentRequired} />
                                                        <TotalCost key="totalCostAtTop" />
                                                        <ErrorMessages />
                                                    </React.Fragment>
                                                }
                                                <SubmitBtn displayDeliveryInputs={displayDeliveryInputs} />

                                                <OrderInfo prepaymentRequired={true} />

                                                {
                                                    !isCustomProduct &&
                                                    <ProductSocialShare product={product} productImage={values.productImage}/>
                                                }
                                                
                                            </div>
                                        </div>
                                    </RGForm>
                                </div>
                            </OrderContext.Provider>
                    }} />
    }
}


export default PhotoFrameForm;




// WEBPACK FOOTER //
// ./src/views/order/PhotoFrameForm.js